import { render, staticRenderFns } from "./AssetCustomFieldModal.vue?vue&type=template&id=4a4498d3&"
import script from "./AssetCustomFieldModal.vue?vue&type=script&lang=js&"
export * from "./AssetCustomFieldModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a4498d3')) {
      api.createRecord('4a4498d3', component.options)
    } else {
      api.reload('4a4498d3', component.options)
    }
    module.hot.accept("./AssetCustomFieldModal.vue?vue&type=template&id=4a4498d3&", function () {
      api.rerender('4a4498d3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/BookingFields/components/AssetCustomFieldModal.vue"
export default component.exports